import api from '@Services/api';
import { AxiosResponse } from 'axios';
import {
	CRUDBase,
	DeleteSingleEntityPayload,
	GenerateCardMeta,
	GetAllMeta,
	GetSingleEntityPayload,
} from 'src/base/services/services.base';
import { stripEmptySortBy } from '@Pages/ScratchCards/Services/ScratchCards.req';
import { InstructorCode } from '../Types/InstructorCodes.types';

export class InstructorCodesRequester implements CRUDBase<InstructorCode> {
	private static instance: InstructorCodesRequester;
	static getInstance() {
		if (!InstructorCodesRequester.instance) {
			InstructorCodesRequester.instance = new InstructorCodesRequester();
		}
		return InstructorCodesRequester.instance;
	}
	baseURL = 'instructor-codes/';
	getAll(
		payload?: GetAllMeta
	): Promise<AxiosResponse<ApiResponse<InstructorCode[]>>>;
	getAll(
		payload: number
	): Promise<AxiosResponse<ApiResponse<InstructorCode[]>>>;
	async getAll(
		payload?: any
	): Promise<AxiosResponse<ApiResponse<InstructorCode[]>>> {
		return await api.post(`${this.baseURL}all`, stripEmptySortBy(payload));
	}
	get(id: string): Promise<AxiosResponse<ApiResponse<InstructorCode>>>;
	get(id: number): Promise<AxiosResponse<ApiResponse<InstructorCode>>>;
	get(
		id: string | number,
		payload: GetSingleEntityPayload
	): Promise<AxiosResponse<ApiResponse<InstructorCode>>>;
	get(
		id: any,
		payload?: any
	): Promise<import('axios').AxiosResponse<ApiResponse<InstructorCode>>> {
		throw new Error('Method not implemented.');
	}
	create(
		payload: Omit<InstructorCode, 'id'>
	): Promise<AxiosResponse<ApiResponse<InstructorCode>>> {
		throw new Error('Method not implemented.');
	}
	update(
		payload: InstructorCode
	): Promise<AxiosResponse<ApiResponse<InstructorCode>>> {
		throw new Error('Method not implemented.');
	}
	delete(id: number): Promise<AxiosResponse<ApiResponse<any>>>;
	delete(id: string): Promise<AxiosResponse<ApiResponse<any>>>;
	delete(
		id: string | number,
		payload: DeleteSingleEntityPayload
	): Promise<AxiosResponse<ApiResponse<any>>>;
	async delete(
		id: any,
		payload?: any
	): Promise<import('axios').AxiosResponse<ApiResponse<any>>> {
		return await api.delete(`${this.baseURL}delete`, { data: { id } });
	}
	async export(payload: GetAllMeta): Promise<AxiosResponse<string>> {
		return await api.post(`${this.baseURL}all`, {
			...stripEmptySortBy(payload),
			export: true,
		});
	}
	async generate?(payload: GenerateCardMeta): Promise<AxiosResponse<string>> {
		return await api.post(`${this.baseURL}generate`, payload);
	}
}
